import { useMemo } from "react";
import { useQueryResponse } from "../core/QueryResponseProvider";
import { ColumnInstance, Row, useTable } from "react-table";
import { Columns } from "./columns/_columns";
import { KTCard, KTCardBody } from "../../../../_mcp/helpers";
import { ListHeader } from "../components/ListHeader";
import { CustomHeaderColumn } from "./columns/CustomHeaderColumn";
import { CustomRow } from "./columns/CustomRow";
import { ListPagination } from "./pagination/ListPagination";

const Table = () => {
  const dataUsers = useQueryResponse();
  const data: any = useMemo(
    () => (dataUsers.response ? dataUsers.response.detailData.docs : []),
    [dataUsers.response]
  );
  const columns = useMemo(() => Columns, []);
  const { getTableProps, getTableBodyProps, headers, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  return (
    <>
      <KTCard>
        <ListHeader />
        <KTCardBody className="py-4">
          <div className="table-responsive">
            <table
              id="kt_table_users"
              className="table table-hover table-rounded border gy-5 gs-5"
              {...getTableProps()}
            >
              <thead className="bg-light">
                <tr className="fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200">
                  {headers.map((column: ColumnInstance<any>) => (
                    <CustomHeaderColumn key={column.id} column={column} />
                  ))}
                </tr>
              </thead>
              <tbody className="fw-semibold text-gray-600" {...getTableBodyProps()}>
                {rows.length > 0 ? (
                  rows.map((row: Row<any>, i) => {
                    prepareRow(row);
                    return <CustomRow row={row} key={`row-${i}-${row.id}`} />;
                  })
                ) : (
                  <tr>
                    <td colSpan={16} className="text-center py-10">
                      <div className="d-flex flex-column align-items-center">
                        <div className="symbol symbol-100px symbol-circle mb-7">
                          <div className="symbol-label fs-1 bg-light-primary text-primary">
                            <i className="fas fa-users"></i>
                          </div>
                        </div>
                        <div className="text-gray-500 fs-4 fw-semibold mb-2">No Users Found</div>
                        <div className="text-gray-400 fs-6">No matching user records were found in the system</div>
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center mt-6 pb-4">
            <ListPagination />
          </div>
        </KTCardBody>
      </KTCard>
    </>
  );
};

export default Table;
